"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _isPromise = _interopRequireDefault(require("is-promise"));

var _dataparcels = _interopRequireDefault(require("dataparcels"));

// $FlowFixMe - useState is a named export of react
// $FlowFixMe - useState is a named export of react
var mergeQueue = function mergeQueue(parcel, queue) {
  if (queue.length < 2) {
    return queue;
  }

  var mergedChangeRequests = queue.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),

    /*parcel*/
    changeRequest = _ref2[1];

    return changeRequest;
  }).reduce(function (prev, next) {
    return prev.merge(next);
  });

  var mergedQueueItem = parcel._changeAndReturn(function (newParcel) {
    return newParcel.dispatch(mergedChangeRequests);
  });

  return [mergedQueueItem];
};

var _default = function _default(params) {
  //
  // state
  //
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      outerParcel = _useState2[0],
      setOuterParcel = _useState2[1]; // innerParcel is a modified parcel derived from outerParcel


  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      innerParcel = _useState4[0],
      setInnerParcel = _useState4[1]; //
  // queue
  //


  var queueRef = (0, _react.useRef)([]);
  var statusRef = (0, _react.useRef)('idle');
  var errorRef = (0, _react.useRef)(undefined); //
  // onChange status
  //

  var getOnChangeStatus = function getOnChangeStatus() {
    var status = statusRef.current;
    var error = status === 'rejected' ? errorRef.current.error : undefined;
    return {
      status: status,
      isPending: status === 'pending',
      isResolved: status === 'resolved',
      isRejected: status === 'rejected',
      error: error
    };
  }; // control contains the hooks control object


  var _useState5 = (0, _react.useState)(getOnChangeStatus),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      onChangeStatus = _useState6[0],
      setOnChangeStatus = _useState6[1];

  var updateOnChangeStatus = function updateOnChangeStatus() {
    return setOnChangeStatus(getOnChangeStatus());
  }; //
  // queue processing
  //


  var processChangeDone = function processChangeDone(onDispatch) {
    return function (result) {
      if (queueRef.current.length > 1) {
        processChange();
      } else {
        var _queueRef$current$shi = queueRef.current.shift(),
            _queueRef$current$shi2 = (0, _slicedToArray2.default)(_queueRef$current$shi, 2),
            newParcel = _queueRef$current$shi2[0],
            _changeRequest = _queueRef$current$shi2[1];

        onDispatch(newParcel, _changeRequest, result);
      }

      updateOnChangeStatus();
    };
  };

  var processChangeSuccess = processChangeDone(function (newParcel, changeRequest, result) {
    if (params.onChange && params.onChangeUseResult) {
      var _newParcel$_changeAnd = newParcel._changeAndReturn(function (newParcel) {
        return newParcel.set(result);
      }),
          _newParcel$_changeAnd2 = (0, _slicedToArray2.default)(_newParcel$_changeAnd, 2),

      /*parcel*/
      changeRequestWithResult = _newParcel$_changeAnd2[1];

      changeRequestWithResult._originId = changeRequest._originId;
      changeRequestWithResult._originPath = changeRequest._originPath;
      changeRequest = changeRequestWithResult;
    }

    statusRef.current = 'resolved';
    params.parcel.dispatch(changeRequest);
  });
  var processChangeError = processChangeDone(function (newParcel, changeRequest, error) {
    changeRequest._revert();

    queueRef.current = [];
    errorRef.current = {
      error: error
    };
    statusRef.current = 'rejected';
  });

  var processChange = function processChange() {
    var onChange = params.onChange; // if no onChange is present, success! skip to the end

    if (!onChange) {
      processChangeSuccess();
      return;
    } // merge remaining changes in the queue together


    queueRef.current = mergeQueue(params.parcel, queueRef.current);
    var result = onChange.apply(void 0, (0, _toConsumableArray2.default)(queueRef.current[0])); // if a promise isn't returned, success! skip to the end

    if (!(0, _isPromise.default)(result)) {
      processChangeSuccess(result);
      return;
    }

    statusRef.current = 'pending';
    updateOnChangeStatus(); // $FlowFixMe - flow can't tell that isPromise() guarantees
    // that this is a promise

    result.then(processChangeSuccess, processChangeError);
  }; //
  // update inner parcel when outer parcel changes (or is first set)
  //


  var newInnerParcel;

  if (params.parcel !== outerParcel) {
    var handleChange = function handleChange(newParcel, changeRequest) {
      // all changes go into the queue
      queueRef.current.push([newParcel, changeRequest]); // if nothing is pending, then call onChange

      if (statusRef.current !== 'pending') {
        processChange();
      }
    };

    newInnerParcel = params.parcel._boundarySplit({
      handleChange: handleChange
    });
    setOuterParcel(params.parcel);
    setInnerParcel(newInnerParcel);
  }

  var returnedParcel = innerParcel || newInnerParcel; //
  // return
  //

  var control = {
    onChangeStatus: onChangeStatus
  };
  return [returnedParcel, control];
};

exports.default = _default;